<div class="container-fluid px-0 px-xl-5 py-4 py-xl-5">
	<div class="container-xl px-xl-0 ml-0">
		<div
			class="d-flex flex-wrap justify-content-between align-items-center mb-4"
		>
			<h2 class="mb-4 mb-md-0">
				{{
					'signature-removal-request_detail-section-snapshot'
						| translate
				}}
			</h2>

			<div *ngIf="isPending()" class="action-buttons">
				<button
					nz-button
					nzType="default"
					class="mr-2"
					(click)="openRejectModal()"
				>
					{{ 'signature-removal-request_action_reject' | translate }}
				</button>
				<button nz-button nzType="danger" (click)="openApproveModal()">
					{{ 'signature-removal-request_action_approve' | translate }}
				</button>
			</div>
		</div>
	</div>

	<div class="container-xl px-xl-0 ml-0">
		<ng-container *ngIf="loading">
			<div class="text-center">
				<app-atom-concept-loader></app-atom-concept-loader>
			</div>
		</ng-container>

		<ng-container *ngIf="!loading && request">
			<div class="snapshot-card">
				<dl class="snapshot-list">
					<div class="snapshot-row">
						<dt>
							{{
								'signature-removal-request_col_formateur'
									| translate
							}}
						</dt>
						<dd>{{ getRequesterLabel() }}</dd>
					</div>
					<div class="snapshot-row">
						<dt>
							{{
								'signature-removal-request_col_stagiaire'
									| translate
							}}
						</dt>
						<dd>{{ getStagiaireLabel() }}</dd>
					</div>
					<div class="snapshot-row">
						<dt>
							{{ 'main_menu-formations' | translate }}
						</dt>
						<dd>{{ getFormationLabel() }}</dd>
					</div>
					<div class="snapshot-row">
						<dt>
							{{
								'signature-removal-request_col_thematique'
									| translate
							}}
						</dt>
						<dd>{{ getThematiqueLabel() }}</dd>
					</div>
					<div class="snapshot-row">
						<dt>
							{{
								'signature-removal-request_col_date' | translate
							}}
						</dt>
						<dd>
							{{
								request.props.attestation_date
									| date : 'dd/MM/yyyy' : '' : 'fr-FR'
							}}
						</dd>
					</div>
					<div class="snapshot-row">
						<dt>
							{{
								'signature-removal-request_col_period'
									| translate
							}}
						</dt>
						<dd>
							{{
								getPeriodKey(request.props.attestation_period)
									| translate
							}}
						</dd>
					</div>
					<div class="snapshot-row">
						<dt>
							{{
								'signature-removal-request_col_status'
									| translate
							}}
						</dt>
						<dd>
							<span
								class="status-tag"
								[attr.data-color]="
									getStatusColor(request.props.status)
								"
							>
								{{
									getStatusKey(request.props.status)
										| translate
								}}
							</span>
						</dd>
					</div>
					<div class="snapshot-row">
						<dt>
							{{
								'signature-removal-request_col_created-at'
									| translate
							}}
						</dt>
						<dd>
							{{
								request.props.created_at
									| date : 'dd/MM/yyyy HH:mm' : '' : 'fr-FR'
							}}
						</dd>
					</div>
					<div class="snapshot-row" *ngIf="request.props.decision_at">
						<dt>
							{{
								'signature-removal-request_col_decision-at'
									| translate
							}}
						</dt>
						<dd>
							{{
								request.props.decision_at
									| date : 'dd/MM/yyyy HH:mm' : '' : 'fr-FR'
							}}
						</dd>
					</div>
					<div class="snapshot-row" *ngIf="request.props.decision_by">
						<dt>
							{{
								'signature-removal-request_col_decided-by'
									| translate
							}}
						</dt>
						<dd>{{ getDecisionByLabel() }}</dd>
					</div>
				</dl>
			</div>
		</ng-container>
	</div>
</div>

<nz-modal
	[(nzVisible)]="approveModal"
	[nzTitle]="'signature-removal-request_confirm-approve-title' | translate"
	(nzOnCancel)="closeApproveModal()"
	(nzOnOk)="confirmApprove()"
	nzOkType="danger"
	[nzOkText]="'signature-removal-request_action_approve' | translate"
	[nzCancelText]="'common_no' | translate"
	[nzOkLoading]="approveLoading"
>
	<p>
		{{ 'signature-removal-request_confirm-approve-content' | translate }}
	</p>
</nz-modal>

<nz-modal
	[(nzVisible)]="rejectModal"
	[nzTitle]="'signature-removal-request_confirm-reject-title' | translate"
	(nzOnCancel)="closeRejectModal()"
	(nzOnOk)="confirmReject()"
	[nzOkText]="'signature-removal-request_action_reject' | translate"
	[nzCancelText]="'common_no' | translate"
	[nzOkLoading]="rejectLoading"
>
	<p>
		{{ 'signature-removal-request_confirm-reject-content' | translate }}
	</p>
</nz-modal>
